const ModelTab = () => {
  return <>modelo</>;
};

export default ModelTab;
